import { createContext, useContext } from 'react';

var defaultThemeContext = {
  isDarkMode: false,
  isOpen: false,
  isTouch: false
};
var SideNavigationThemeContext = createContext(defaultThemeContext);
var SideNavigationThemeProvider = SideNavigationThemeContext.Provider;
var useSideNavigationThemeContext = function useSideNavigationThemeContext() {
  return useContext(SideNavigationThemeContext);
};

export { SideNavigationThemeProvider, defaultThemeContext, useSideNavigationThemeContext };
//# sourceMappingURL=SideNavigationThemeContext.js.map
